<template>
  <div>
    <a-drawer
      title="添加角色"
      placement="right"
      width="500"
      :closable="false"
      @close="onClose"
      :visible="visible"
    >
      <a-form :form="form" @submit="saveColumnData">
        <a-form-item
          label="角色名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'role_name',
              {
                rules: [{ required: true, message: '请输入您的角色名称' }]
              }
            ]"
            placeholder="请输入您的角色名称"/>
        </a-form-item>
        <a-form-item
          :required="true"
          label="状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-model="addRoleData.role_status">
            <a-radio-button v-if="status.id !== ''" v-for="status in statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-decorator="[
              'role_desc',
              {
                rules: [{ required: true, message: '请输入您的备注' }]
              }
            ]"
            :rows="6"
            placeholder="请输入您的备注"/>
        </a-form-item>
        <a-form-item :wrapperCol="{span: 12, offset: 9}">
          <a-button style="margin-right:20px" html-type="submit" type="primary" :loading="loading">下一步</a-button>
          <a-button @click="onClose">取消</a-button>
        </a-form-item>
      </a-form>
      <!-- 权限设置抽屉 -->
      <rolePermission v-if="rolePermissionVisible" :visible="rolePermissionVisible" :roleId="roleId" @hide="handelRolePermission" @finish="finish"></rolePermission>
    </a-drawer>
  </div>
</template>
<script>
import { postRoleBasicInfo } from '@/api/role'
import rolePermission from './rolePermission'
import _ from 'lodash'
export default {
  components: {
    rolePermission
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 按钮加载
      loading: false,
      // 添加角色数据
      addRoleData: {
        role_name: '',
        role_desc: '',
        role_status: 'NORMAL'
      },
      // 权限设置抽屉状态开关
      rolePermissionVisible: false,
      // 角色ID
      roleId: '',
      statusDict: [
        { id: 'NORMAL', name: '正常' },
        { id: 'FORBIDDEN', name: '禁用' }
      ]
    }
  },
  methods: {
    // 权限设置完成相应事件
    finish () {
      this.handelRolePermission()
      setTimeout(() => { this.$emit('finish') }, '500')
    },
    // 关闭权限设置抽屉
    handelRolePermission () {
      this.rolePermissionVisible = false
    },
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    // 抽屉保存按钮
    saveColumnData (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.addRoleData.role_name = fieldsValue['role_name']
          this.addRoleData.role_desc = fieldsValue['role_desc']
          postRoleBasicInfo(this.addRoleData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.roleId = _.get(res, 'data')
              this.rolePermissionVisible = true
              this.loading = false
              this.$message.success('添加角色成功')
            } else this.loading = false
          })
        } else this.loading = false
      })
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
